"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.path = exports.requestSchema = void 0;
const zod_1 = require("zod");
exports.requestSchema = zod_1.z.object({
    propertyIds: zod_1.z.array(zod_1.z.number()),
});
exports.path = '/service-center-node-logs-get';
//# sourceMappingURL=index.js.map